import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Contract } from '../store';
import { Account } from '../../store';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { AccountContract } from '../../store/account-contract.model';
import { IStatusMessage, ResponseStatus } from '../../../shared';
import { IShowErrors } from '../../../shared/errors-sidenav';

@Component({
    selector: 'ef-account-allocations',
    templateUrl: './account-allocations.component.html',
    styleUrls: ['./account-allocations.component.scss'],
    standalone: false
})
export class AccountAllocationsComponent implements OnInit {
    hideARContract = true;
    showFacilityAllocation = false;
    @Input() accounts: Account[];
    public get arAccounts(): Account[] {
        return this.accounts.filter(
            x => x.AccountType.toLocaleLowerCase() === 'accountsreceivable'
        );
    }
    @Input() contracts: AccountContract[];
    @Input() selectedError: IStatusMessage;

    @Output() public ShowError = new EventEmitter<IShowErrors>();
    constructor(private log: LoggingService) {}

    ngOnInit() {}
    onHasFacilityExpense($event: boolean) {
        this.log.verbose({
            type: 'AccountAllocationsComponent:onHasFacilityExpense',
            $event
        });
        this.showFacilityAllocation = $event;
    }
    onStatusClick(item: Account) {
        this.log.verbose({
            type: 'AccountAllocationsComponent:onStatusClick',
            item
        });
        this.ShowError.emit({ open: true, MsgEntityID: item.AccountListID });
    }
}
